import React, { Component } from 'react';
import { connect } from 'react-redux';
import { selectedPatient } from '../../actions';
import PhotoExternal from'../../components/cards/Photo/PhotoExternal';
import PhotoMacro from'../../components/cards/Photo/PhotoMacro';
import PhotoDermoscopy from'../../components/cards/Photo/PhotoDermoscopy';
//import PhotoDisplay from '../../components/cards/Photo/PhotoDisplay';

class Photo extends Component {

    componentDidMount() {
        this.props.selectedPatient(this.props.match.params.id);
    }

    componentDidUpdate() {
        this.props.selectedPatient(this.props.match.params.id);
    }
    
    render() {

        var permit = this.props.selectedPermission.permission[0].photo;

        if (permit === "Blocked") {
            return <div className='permissionCard'>View not permitted</div>
        }

        else if (permit === "View Only") {
            return <div>View only</div>
        }

        else {
            return (
                <div className='flex-container' >
                    <PhotoExternal />
                    <PhotoMacro />
                    <PhotoDermoscopy />
                </div>
            )
        }
    }
}


const mapStateToProps = (state) => {
    return { 
        selectedPermission : state.selectedPermission
    }
}

export default connect(mapStateToProps, {selectedPatient})(Photo);
